import api from 'api';
import { components } from 'api/types';

export type NodeLocalFilesPreview = components['schemas']['NodeLocalFilesPreview'];
export type NodeLocalFilesRecycleAccepted = components['schemas']['NodeLocalFilesRecycleAccepted'];

export function fetchNodeLocalFiles(nodeAgentId: string) {
  return api.get(`node-agents/${nodeAgentId}/local-files`).json<NodeLocalFilesPreview>();
}

export function recycleNodeLocalFiles(nodeAgentId: string) {
  return api.post(`node-agents/${nodeAgentId}/local-files/recycle`).json<NodeLocalFilesRecycleAccepted>();
}
